import { render, staticRenderFns } from "./bannerProduct.vue?vue&type=template&id=26effcca&scoped=true"
import script from "./bannerProduct.vue?vue&type=script&lang=ts"
export * from "./bannerProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26effcca",
  null
  
)

export default component.exports